import { combineReducers } from 'redux';

import login from './loginReducer';
import logout from './logoutReducer';
import rolesPermission from './rolesPermissionsReducer'; 
import skills from './settings/superadmin/skillReducer';
import sectors from './settings/superadmin/sectorReducer';
import subSectors from './settings/superadmin/subSectorReducer';
import otherExps from './settings/otherExpReducer';
import omnuPoints from './settings/superadmin/omnuPointsReducer';
import userDocs from './settings/userDocReducer';
import emailVerify from './emailVerifyReducer';
import refreshToken from './refreshTokenReducer';
import affiliates from './affiliateReducer';
import setPassword from './setPasswordReducer'; 
import afltSkills from './settings/affiliates/skillReducer';
import commons from './commonReducer';
import afltAppayrate from './settings/affiliates/appayrateReducer'; 
import afltSTCBonus from './settings/affiliates/stcbonusReducer'; 
import keyLocation from './settings/affiliates/keyLocationReducer';
import eventLocation from './settings/affiliates/eventLocationReducer';
import afltDepartments from './settings/affiliates/departmentsReducer';
import afltRateCards from './settings/affiliates/rateCardsReducer';
import changePassword from './changePasswordReducer'; 
import masterRateCard from './settings/affiliates/masterratecardReducer';
import clients from './clientReducer';
import crews from './crewReducer';
import dynamicFields from './settings/dynamicfieldsReducer'; 
import clientRateCard from './clientRateCardReducer';
import activityLog from './activityLogReducer';
import document from './documentReducer';
import assocUsers from './assUserReducer';
import event from './eventReducer';
import fcmNotifiToken from './fcmReducer';
import countryList from './countryListReducer';
import loader from './loaderReducer';
import timeZones from './timeZonesListReducer';
import timesheet from './timesheetReducer';
import feedback from './feedbackReducer';
import unavailability from './unavailabilityReducer';
import serverTimeList from './serverTimeReducer';
import actionRequiredItems from './dashboardReducer';
import filterItems from './filterReducer';
import payLevel from './settings/affiliates/payLevelReducer';
import superAdmin from  './superAdminReducer'; 
import certificates from './settings/affiliates/certificateReducer';
import omnuppSettings from './settings/superadmin/ppSettingReducer';
import validate from './validateReducer';
import clientMasterCategories from './settings/superadmin/clientCategoryReducer.js';
import clientCategories from './settings/affiliates/clientCategoryReducer.js';
import vehicleInfo from './vehicleInfoReducer.js';
import cancelReasons from './cancelReasons.js';
import terms from './termsReducer';  
import vehicleMasterInfo from './settings/superadmin/vehicleInfoMasterReducer.js';
import travelModule from './travelModuleReducer.js';
import csvTemplateImport from './settings/csvTemplatesImportReducer.js';


const appReducer = combineReducers({
  login, 
  logout,
  emailVerify, 
  refreshToken:refreshToken,
  skills:skills,
  sectors:sectors,
  rolesPermission:rolesPermission,
  subSectors:subSectors,
  otherExps:otherExps,
  omnuPoints:omnuPoints,
  userDocs:userDocs,
  affiliates:affiliates,
  setPassword:setPassword, 
  afltSkills:afltSkills,
  commons:commons,
  afltAppayrate:afltAppayrate,
  afltSTCBonus:afltSTCBonus, 
  keyLocations:keyLocation,
  eventLocations:eventLocation,
  afltDepartments:afltDepartments,
  afltRateCards:afltRateCards,
  changePassword:changePassword,
  masterRateCard:masterRateCard,
  clients:clients,
  crews:crews,
  dynamicFields:dynamicFields,
  clientRateCard:clientRateCard,
  activityLog:activityLog,
  document:document,
  assocUsers:assocUsers,
  event:event,
  fcmNotifiToken:fcmNotifiToken,
  countryList:countryList,
  loader:loader,
  timeZones:timeZones,
  timesheet:timesheet,
  feedback:feedback,
  unavailability:unavailability,
  serverTimeList:serverTimeList,
  actionRequiredItems:actionRequiredItems,
  filterItems:filterItems,
  payLevel:payLevel,
  superAdmin:superAdmin,
  certificates:certificates,
  omnuppSettings:omnuppSettings,
  validate:validate,
  clientMasterCategories:clientMasterCategories,
  clientCategories:clientCategories,
  vehicleInfoData:vehicleInfo,
  travelModule:travelModule, 
  cancelReasons:cancelReasons,
  terms:terms,
  vehicleMasterInfo:vehicleMasterInfo,
  csvTemplateImport:csvTemplateImport,
});

const rootReducer = ( state, action ) => {

  if ( action.type === 'LOGOUT_USER' ) {
    state = {};
  }      
  return appReducer(state, action)
}

export default rootReducer;